import axios from "axios";
import { DataResponse, ServerResponse } from "models/common/responseObjects";
import { DashboardWidget } from "models/dbModels/dashboards/DashboardWidget";
import { DashboardsFilterQuery } from "models/filters/dashboards/DashboardsFilterQuery";
import { DashboardWidgetsFilterQuery } from "models/filters/dashboards/DashboardWidgetsFilterQuery";
import { AdminDashboard, DashboardData } from "models/storeModels/DashboardData";

export class DashboardsApi {
    static Search = async (query: DashboardsFilterQuery) => axios.post<ServerResponse<DataResponse<DashboardData>>>(`api/v1/Dashboards/Search`, query);
    static SearchWidgets = async (query: DashboardWidgetsFilterQuery) => axios.post<ServerResponse<DataResponse<DashboardWidget[]>>>(`api/v1/Dashboards/SearchWidgets`, query);
    static AddOrEdit = async (query: DashboardData[]) => axios.put<DataResponse<boolean>>(`api/v1/Dashboards/AddOrEdit`, query);

    static AdminStats = async () => axios.post<DataResponse<AdminDashboard[]>>(`api/v1/Dashboards/AdminStats`);
}